class SearchController {
    constructor($scope,$sce, $stateParams, QueryAPI, $state,$q, $timeout,CollectionAPI,userInfo,message,fancyboxService,$filter) {
        "ngInject";

        $scope.searchText = '';
        $scope.searchClicked = false;
        $scope.unavailableImages = {};

        this.items = [];
        this.pageSize = 40;
        this.pageCount = 0;
        this.page = 1;
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams=$stateParams;
        this.QueryAPI = QueryAPI;
        this.$timeout = $timeout;
        this.loading = false;
        this.CollectionAPI=CollectionAPI;
        this.userInfo=userInfo;
        this.userInfo.setUser(this.appUser);
        this.message=message;
        this.searchTotal=0;
        this.$q=$q;
        this.tranlsteFilter=$filter('translate');
        let self = this;

        this.original_type='article';
        this.$sce = $sce;
        this.hotSearchOptions=['金融科技','人工智能','区块链','设计','VR','供应链','互联网创业','商业','电影']


        this.fancyboxOptions = fancyboxService.getOptions((title, currentArray, currentIndex, currentOpts) => {
            return '<div class="image-description">' +
                '<div class="image-title">' + title + '</div>' +
                '<div class="description-content">' + self.items[currentIndex].description + '</div>' +
                '</div>'
        });

        this.cata={
            items:[
              {text:self.tranlsteFilter('page-search-text014'),value:'new'},
              {text:self.tranlsteFilter('page-search-text013'),value:'hot'},
            ]
        };
        this.cata.selected=this.cata.items[0];
        this.type={
            items:[
                {text:self.tranlsteFilter('page-search-text015'),value:''},
                {text:self.tranlsteFilter('page-search-text016'),value:'cc'},
                {text:self.tranlsteFilter('page-search-text017'),value:'cm'}
            ]
        };
        this.type.selected=this.type.items[0];
        this.range={
            items:[
                {text:self.tranlsteFilter('page-search-text018'),value:''},
                {text:self.tranlsteFilter('page-search-text019'),value:{gte:0,lte:500}},
                {text:self.tranlsteFilter('page-search-text020'),value:{gte:600,lte:1000}},
                {text:self.tranlsteFilter('page-search-text021'),value:{gte:1100,lte:5000}},
                {text:self.tranlsteFilter('page-search-text022'),value:{gt:5000}}
            ]
        };
        this.range.selected=this.range.items[0];


        this.rank={
            text:self.tranlsteFilter('page-search-text023'),
            value:'high_price'
        }

        this.$onInit = function () {
            if ($stateParams.q) {
                $scope.searchText = $stateParams.q;
            }
            if($stateParams.original_type){
                self.original_type=$stateParams.original_type;
            }
            self.search();
        };

    }
    isAuthor(originals){
        if(this.original_type=='article'){
            let user_id=originals.user_id;
            if(user_id==this.appUser.id){
                return true
            }
            return false;
        }else{
            let reg=/(<span class="highlight">)|(<\/span>)/g;
            let str=originals.author_name.replace(reg,'');
            if(str===this.appUser.pseudonym){
                return true
            }
            return false;
        }


    }
    swtichRank(){
        if(this.rank.value=='high_price'){
            this.rank.value='low_price';
            this.rank.text=this.tranlsteFilter('page-search-text024');
        }else{
            this.rank.value='high_price';
            this.rank.text=this.tranlsteFilter('page-search-text023');
        }
        this.search();

    }

    search() {
        if (this.$scope.searchText == '') {
            return;
        }

        if (this.loading) {
            return;
        }

        let query = {};
        query['q'] = this.$scope.searchText;
        query['page'] = this.page;
        query['page_size'] = this.pageSize;
        console.log(this.cata.selected.value)
        if (this.cata.selected.value !== 'all') {
            query['sort']=this.cata.selected.value
        }
        if(this.type.selected.value){
            query['license_type']=this.type.selected.value;
            if(this.type.selected.value=='cm'){
                query['sort']=this.rank.value+','+this.cata.selected.value;
                if(this.range.selected.value){
                    Object.keys(this.range.selected.value).forEach((key)=>{

                        query['range['+key+']']=this.range.selected.value[key]
                    })

                }

            }
        }
        query['type'] = this.original_type;
        //更新url 回退时候可查看上次查找的内容
        // this.$state.go('app.page.search', {q: this.$scope.searchText,original_type:this.original_type}, {notify: false,reload:false})
        // let url=window.location.href+'?q='+this.$scope.searchText+'&original_type='+this.original_type;
        // window.history.replaceState({},'',url);
        this.loading = true;

        let self = this;

        this.QueryAPI.one().get(query).then(
            function success(data) {
                self.searchTotal=data.total;
                self.pageCount = Math.ceil(data.total / self.pageSize);
                self.$scope.searchClicked = true;
                self.items.length = 0;
                data.items.forEach((image) => {
                    if(!image.license){
                        image.user={};
                        image.title=self.tranlsteFilter('page-search-text025');
                        image.license={type: "cc0", content: {adaptation: "y", commercial: "y"}};
                        image.isCC0=true;
                    }
                    self.items.push(image);
                });
                self.loading = false;
                $('body').scrollTop(0);

                if(query['type']=='image'){
                    self.$timeout(() => {
                        $(".yb-view-btn").fancyboxPlus(self.fancyboxOptions);
                    });
                }
                if(!self.userInfo.isGuest() && data.items.length){
                    //不是访客且以获取到数据
                    self.collection_check(query['type']=='article'?1:2,self.items)
                }
            },
            function error() {
                self.$scope.searchClicked = true;
                self.loading = false;
            }
        );
    }

    searchArticle() {
        this.original_type='article'
        this.switchType();
    }

    searchImage() {
        this.original_type='image'
        this.switchType();
    }

    switchType() {
        //每次搜索初始化
        this.items = [];
        this.pageCount = 0;
        this.page = 1;
        this.cata.selected=this.cata.items[0];
        this.type.selected=this.type.items[0];
        this.range.selected=this.range.items[0];
        this.rank.value='high_price';
        this.rank.text=this.tranlsteFilter('page-search-text023');

        this.search();
    }

    loadPage(page) {
        this.page = page;
        this.search();
    }
    collection(originals,type){
        if(this.userInfo.isGuest()){
            this.$state.go('app.face.index.user.form.login');
            return;
        }
        let self = this;
        originals.collection_loading=true;
        let api=this.CollectionAPI;
        if(originals.collectStatue){
            api.one().remove({resource_type_id: type, resource_id: originals.id}).then(
                () => {
                    originals.collection_loading = false;
                    self.message.success(self.tranlsteFilter('page-search-text026'));
                    originals.collectStatue=false
                },
                (response) => {
                    originals.collection_loading = false;
                    self.message.error(response.data);
                }
            );
        }else{
            api.post({resource_type_id: type, resource_id: originals.id}).then(
                (res) => {
                    originals.collection_loading = false;
                    if(res.status.code==200){
                        self.message.success(self.tranlsteFilter('page-search-text027'));
                        originals.collectStatue=true
                    }else{
                        self.message.error(self.tranlsteFilter('page-search-text028'));
                        originals.collectStatue=false
                    }

                },
                (response) => {
                    originals.collection_loading = false;
                    self.message.error(response.data);
                }
            );
        }

    }
    collection_check(type,originals){
        let self=this;
        if(type==1){
            //文章
            let ids=originals.map(function (item) {
                return item.id
            });
            self.CollectionAPI.one('check').customPOST({resource_type_id: type, resource_ids: ids}).then(
                (res) => {
                    //获取已收藏的数据
                    let collectArr=res.data.filter((item)=>{
                        return item.is_active===1
                    });
                    self.compare(collectArr,originals)
                },
                (err) => {

                }
            );
        }else{
            let cc0_ids=[], license_ids=[];
            originals.forEach((item)=>{
                if(!item.isCC0){
                    license_ids.push(item.id)
                }else{
                    cc0_ids.push(item.id)
                }
            });


            let license_defer = self.$q.defer();
            if(license_ids.length){
                self.CollectionAPI.one('check').customPOST({resource_type_id:2, resource_ids: license_ids}).then(
                    (res) => {
                        //获取已收藏的数据
                        let licenseArr=res.data.filter((item)=>{
                            return item.is_active==1
                        });
                        license_defer.resolve(licenseArr)
                    }
                );
            }else{
                license_defer.resolve([])
            };
            let cc0_defer = self.$q.defer();
            if(cc0_ids.length){
                self.CollectionAPI.one('check').customPOST({resource_type_id:3, resource_ids: cc0_ids}).then(
                    (res) => {
                        //获取已收藏的数据
                        let cc0Arr=res.data.filter((item)=>{
                            return item.is_active==1
                        });
                        cc0_defer.resolve(cc0Arr)
                    }
                );
            }else{
                cc0_defer.resolve([])
            }
            self.$q.all([license_defer.promise,cc0_defer.promise]).then((res)=>{
                res=res[0].concat(res[1]);
                self.compare(res,originals)
            })

        }

    }
    hotsearch(text){
        this.$scope.searchText=text;
        // this.$state.go('app.page.search', {q: this.$scope.searchText,original_type:this.original_type});
        this.switchType();
    }
    compare(collectArr,originals){
        collectArr && collectArr.forEach((collectItem)=>{
            originals.forEach((originalItem)=>{
                if(originalItem.id===collectItem.resource_id){
                    originalItem.collectStatue=true;
                    return true;
                }
            })
        })
    }

}

export default SearchController;



// WEBPACK FOOTER //
// ./src/app/components/page/search/search.controller.js